import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import BlogListWidget from "./BlogListWidget";
import OCVBlogDetail from "./BlogListDetail";
import axios from "axios";

export default function BlogPost({
  route,
  manifestData,
  anchorID,
}: Record<string, any>): JSX.Element {
  const [data, setData] = React.useState<any>({});
  const [page, setPage] = React.useState<number>(1);
  const [previousQuery, setPreviousQuery] = React.useState<string>("");
  const [totalEntries, setTotalEntries] = React.useState<number>(1);
  const [query, setQuery] = React.useState<string>("");
  const [limit, setLimit] = React.useState<number>(manifestData.config.limit);
  const [sort, setSort] = React.useState(
    manifestData.config.sortOrder || "dateDesc"
  );
  const appID = manifestData.config.appID;
  const blogKey = manifestData.config.blogKey;
  const charLength = manifestData.config?.charLength;
  const dateFormat = manifestData.config?.dateFormat;
  const displayDate = manifestData.config?.displayDate;
  const hideSortByDate = manifestData.config?.hideSortByDate;
  const maxHeight = manifestData.config?.maxHeight;
  const showImage = manifestData.config?.showImage;
  const showSearch = manifestData.config?.showSearch;
  const showSort = manifestData.config?.showSort;
  const sortOrder = manifestData.config?.sortOrder;
  const totalPages = Math.ceil(totalEntries / limit);
  const truncate = manifestData.config?.truncation;
  const type = manifestData.config.type;

  function checkPageLeft() {
    if (page !== 1) {
      setPage(page - 1);
    }
  }

  function checkPageRight() {
    if (page !== totalPages - 1) {
      setPage(page + 1);
    }
  }

  useEffect(() => {
    setPreviousQuery(query);
    if (query === "") {
      axios
        .get(
          `https://okhugm75f7.execute-api.us-east-1.amazonaws.com/dev/paginatedBlog/${appID}?blogKey=${blogKey}&limit=${limit}&sort=${sort}&type=${type}&page=${page}`
        )
        .then((response: any) => {
          setData(response.data);
          setTotalEntries(response.data.pagination.totalEntries);
          setLimit(manifestData.config.limit);
          if (query !== previousQuery) setPage(1);
        })
        .catch((error: any) => {
          console.log(error);
        });
    } else {
      axios
        .get(
          `https://okhugm75f7.execute-api.us-east-1.amazonaws.com/dev/paginatedSearch/${appID}?blogKey=${blogKey}&limit=${limit}&q=${query}&type=${type}&page=${page}`
        )
        .then((response: any) => {
          setData(response.data);
          setTotalEntries(response.data.pagination.totalEntries);
          setLimit(manifestData.config.limit);
          if (query !== previousQuery) setPage(1);
        })
        .catch((error: any) => {
          console.log(error);
        });
    }
  }, [
    page,
    query,
    sort,
    sortOrder,
    appID,
    blogKey,
    limit,
    type,
    previousQuery,
    manifestData.config.limit,
  ]);

  return (
    <div
      id={anchorID}
      style={{
        backgroundColor: manifestData.config.backgroundColor
          ? manifestData.config.backgroundColor
          : "#eee",
      }}
    >
      <Routes>
        <Route
          index
          element={
            <BlogListWidget
              charLength={charLength}
              data={data}
              dateFormat={dateFormat}
              displayDate={displayDate}
              handlePageLeft={() => checkPageLeft()}
              handlePageRight={() => checkPageRight()}
              hideSortByDate={hideSortByDate}
              limit={limit}
              maxHeight={maxHeight}
              page={page}
              query={query}
              route={route}
              setPage={setPage}
              setQuery={setQuery}
              setSort={setSort}
              showImage={showImage}
              showSort={showSort}
              showSearch={showSearch}
              sortOrder={sortOrder}
              totalEntries={totalEntries}
              truncate={truncate}
            />
          }
        />
        {data.entries && data.entries.length !== 0 ? (
          <Route
            path={":id"}
            element={
              <OCVBlogDetail
                blogEntries={
                  data.entries && data.entries.length > 0 ? data.entries : []
                }
                dateFormat={dateFormat}
                displayDate={displayDate}
                route={route}
                showImage={showImage}
              />
            }
          />
        ) : (
          ""
        )}
      </Routes>
    </div>
  );
}
